export default "__VITE_ASSET__CaJHnL7W__"